import React from 'react'
import ReactDOM from 'react-dom/client'
import { GoogleOAuthProvider } from '@react-oauth/google'
import App from './App'
import './index.css'

const CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID

if (!CLIENT_ID) {
  console.warn(
    'VITE_GOOGLE_CLIENT_ID is not set — Google Sign-In will not work. ' +
    'Set this in .env before running dev/build.'
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={CLIENT_ID || 'MISSING'}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>,
)
